import {
  LayoutDashboard,
  ShoppingCart,
  LayoutGrid,
  ReceiptText,
  ChefHat,
  BookOpen,
  Boxes,
  Users,
  UserCog,
  BarChart3,
  CalendarClock,
  Wallet,
  Settings,
  ShieldCheck,
  CheckCircle2,
  Headphones,
  Handshake,
} from "lucide-react";

// module key must match backend ROLE_PERMISSIONS module names

export const NAV = [
  {
    key: "dashboard",
    label: "Dashboard",
    to: "/app",
    icon: LayoutDashboard,
    module: "dashboard",
  },

  {
    key: "pos",
    label: "POS / Billing",
    to: "/app/pos",
    icon: ShoppingCart,
    module: "pos",
  },

  {
    key: "approvals",
    label: "Approvals",
    to: "/app/approvals",
    icon: CheckCircle2,
    module: "approvals",
  },

  {
    key: "tables",
    label: "Tables",
    to: "/app/tables",
    icon: LayoutGrid,
    module: "tables",
  },

  {
    key: "orders",
    label: "Orders",
    to: "/app/orders",
    icon: ReceiptText,
    module: "orders",
  },

  {
    key: "kitchen",
    label: "Kitchen (KDS)",
    to: "/app/kitchen",
    icon: ChefHat,
    module: "kitchen",
  },

  {
    key: "menu",
    label: "Menu",
    to: "/app/menu",
    icon: BookOpen,
    module: "menu",
  },

  {
    key: "inventory",
    label: "Inventory",
    to: "/app/inventory",
    icon: Boxes,
    module: "inventory",
  },

  {
    key: "customers",
    label: "Customers",
    to: "/app/customers",
    icon: Users,
    module: "customers",
  },

  {
    key: "reservations",
    label: "Reservations",
    to: "/app/reservations",
    icon: CalendarClock,
    module: "reservations",
  },

  {
    key: "staff",
    label: "Staff",
    to: "/app/staff",
    icon: UserCog,
    module: "staff",
  },

  {
    key: "expenses",
    label: "Expenses",
    to: "/app/expenses",
    icon: Wallet,
    module: "expenses",
  },

  {
    key: "reports",
    label: "Reports",
    to: "/app/reports",
    icon: BarChart3,
    module: "reports",
  },

  {
    key: "support",
    label: "Support",
    to: "/app/support",
    icon: Headphones,
    module: "support",
  },

  {
    key: "settings",
    label: "Settings",
    to: "/app/settings",
    icon: Settings,
    module: "settings",
  },
  {
    key: "sales_partners",
    label: "Sales Partners",
    to: "/app/admin/sales-partners",
    icon: Handshake,
    module: "sales_partners",
  },

  {
    key: "admin",
    label: "Super Admin",
    to: "/app/admin",
    icon: ShieldCheck,
    module: "super_admin",
  },
];

// ---------------------------------------------------------
// Modules available to Super Admin
// ---------------------------------------------------------
const SUPER_ADMIN_MODULES = new Set(["support", "super_admin", "sales_partners"]);

export const canAccess = (user, module) => {
  if (!user) return false;

  // Super Admin has its own explicit navigation rules.
  // Do this BEFORE wildcard permission handling.
  if (user.role === "super_admin") {
    return SUPER_ADMIN_MODULES.has(module);
  }

  const perms = user.permissions || [];

  if (perms.includes("*")) return true;

  return perms.includes(module);
};
